import * as React from 'react';
import { useEffect } from 'react';
import { BodyText, BoldBodyText, Card, ErrorMessage, Grid } from 'ui-toolkit';
import { ClientDetailsHeader } from '../../components/clients/ClientDetailsHeader';
import { clientNavigationOptions } from '../../router/admin/ClientLenderCompaniesRouter';
import { useSelector } from 'react-redux';
import { RootStore } from '../../store/types';
import { useAppDispatch } from '../../store/store';
import { initClientOverview } from '../../store/client/clientOverviewDispatch';
import { useParams } from 'react-router-dom';
import { UUID } from '../../types/shared/UUID';

export const ClientOverviewPage: React.FC = () => {
  const { clientId } = useParams<{ clientId: UUID }>();
  const dispatch = useAppDispatch();
  const { clientOverview } = useSelector((state: RootStore) => state.usersCollection);

  useEffect(() => {
    dispatch(initClientOverview(clientId));
  }, [clientId, dispatch]);

  return (
    <Grid>
      <ErrorMessage message={clientOverview.fetchError?.message} />
      <ClientDetailsHeader
        clientId={clientId}
        companyName={clientOverview.data.name}
        currentPageLink={clientNavigationOptions(clientId)[1].to || ''}
      />
      <Card title={`Client Information`}>
        <hr />
        <Grid columnCount={2}>
          <BoldBodyText>Spruce email address</BoldBodyText>
          <BodyText>{clientOverview.data.spruceEmail}</BodyText>
        </Grid>
      </Card>
    </Grid>
  );
};
